import React, { lazy, useEffect } from 'react'
import { useFeatureFlagVariantKey } from '@posthog/react'
import posthog from 'posthog-js'
import { get as getConfig } from '../../config/index'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'
import { POSTHOG_FEATURE_FLAGS } from '../PostHog/index'

const LoadableSearch = lazy(
  () => import('../SearchPage/index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)
const LoadableAiGuideSearch = lazy(
  () => import('../AiGuideSearchPage/index'),
  { fallback: <Sherpa type={TYPE_LARGE} /> },
)

export default function SearchPageSwitch (props) {
  const config = getConfig()
  const configEnabled = !!config?.features?.ai?.aiGuideSearchPage
  const isPostHogEnabled = !!config?.features?.posthog
  const aiSearchVariant = useFeatureFlagVariantKey(
    POSTHOG_FEATURE_FLAGS.AI_SEARCH_WEB,
  )

  const showAiSearch = configEnabled && (!isPostHogEnabled || aiSearchVariant === 'test')

  // Track experiment exposure for the AI Search A/B test.
  // Must be here (not in AiGuideSearchPage) because control users
  // never render AiGuideSearchPage — they get the standard SearchPage.
  useEffect(() => {
    if (aiSearchVariant && (aiSearchVariant === 'test' || aiSearchVariant === 'control')) {
      posthog.capture('experiment_exposure', {
        '$feature/ai-search-web': aiSearchVariant,
        experiment: 'ai-search-web',
      })
    }
  }, [aiSearchVariant])

  if (showAiSearch) {
    return <LoadableAiGuideSearch history={props.history} location={props.location} />
  }
  return <LoadableSearch history={props.history} location={props.location} />
}
